module.exports = __webpack_public_path__ + "32ccb704b1f0366f2ca1f70b7a3c7366.svg";


//////////////////
// WEBPACK FOOTER
// ./src/ui/assets/images/icons/table_dropdown_icon.svg
// module id = 520
// module chunks = 0